import React from 'react';
import Navbar from '../components/Navbar';
import '../../components/ui/ui.css';
import './index.css';

const DashboardLayout = ({ title, subtitle, children, actions }) => {
  return (
    <div className="ui-page-shell">
      <Navbar />
      <main className="ui-container dashboard-layout-container">
        <section className="dashboard-layout-header">
          <div>
            <h1>{title}</h1>
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          {actions ? <div>{actions}</div> : null}
        </section>
        {children}
      </main>
    </div>
  );
};

export default DashboardLayout;
